module.exports = __webpack_public_path__ + "img/icicles.08657e9a.svg";